/* istanbul ignore file */
import { ref } from 'vue';

/**
 *
 * @param {number} autoplayInterval
 * @param {(flag: number) => boolean} moveCallback
 */
const useSlideshowAutoplay = (autoplayInterval, moveCallback) => {
  const timer = ref(null);

  const start = () => {
    clearInterval(timer.value);
    timer.value = setInterval(() => {
      moveCallback(1);
    }, autoplayInterval);
  };

  const stop = () => {
    clearInterval(timer.value);
    timer.value = null;
  };

  return {
    timer,
    start,
    stop,
  };
};

export default useSlideshowAutoplay;
